export const openLinkInTab = (link, target) => {
    const Link = document.createElement('a')
    Link.href = link
    Link.target = target
    Link.click()
}
